export function productionHoursTohoursMinutes(productionHours: number){
    const decimalHours = productionHours / 60;
    const hours = Math.floor(decimalHours)
    const decimalPart = decimalHours - hours;
    const minutes = Math.round(decimalPart * 60);
    return { hours, minutes };
  }